import { Candidate, Group } from '$synapse/models';
import { GroupService } from '$synapse/services';
import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CandidatePickerComponent } from '../../../core/components/candidate-picker/candidate-picker.component';
import { SHARED_IMPORTS } from '../../../core/shared-imports';

@Component({
  selector: 'syn-group-add-candidates',
  templateUrl: './group-add-candidates.component.html',
  imports: [SHARED_IMPORTS, CandidatePickerComponent],
})
export class GroupAddCandidatesComponent {
  readonly group = inject<Group>(MAT_DIALOG_DATA);
  private readonly _groupService = inject(GroupService);
  readonly _modalDisplay =
    inject<MatDialogRef<GroupAddCandidatesComponent>>(MatDialogRef);

  candidatesToAdd: string[];
  send = false;

  submit(): void {
    this.send = true;
    this._groupService
      .addCandidatesToGroup(this.group, this.candidatesToAdd)
      .subscribe((candidates: Candidate[]) => {
        this._modalDisplay.close(candidates);
      });
  }

  addCandidate(event: string[]) {
    if (event) {
      this.candidatesToAdd = event;
    }
  }
}
